<script>
    import {
        findings,
        handleOwnerChange,
        handleStatusChange,
        hydrateFindingsWithTags,
        replaceFindingsListElements,
        searchFindings,
    } from "../findings.state.svelte.js";
    import { PowerTable } from "@muonw/powertable";
    import { onMount, tick, onDestroy } from "svelte";
    import powerTableService from "../../../services/powerTable.js";
    import { notificate } from "../../../services/notification";
    import userService from "../../user/service.svelte.js";
    import {
        dateText,
        normalizeString,
        sortAllAssets,
    } from "../../../js/utils.js";
    import EditForm from "../_edit_form.svelte";
    import TagForm from "../../tag/_form.svelte";
    import RemoveFindingTag from "./remove-finding-tag.svelte";
    import FindingTableHtmlRow from "../../../components/powerTable/findingTable-html-row.svelte";
    import FindingAssetRow from "../../../components/powerTable/finding-asset-row.svelte";
    import DescriptionRow from "../../../components/powerTable/description-row.svelte";
    import MassiveActionsService from "../../../services/massive-actions.js";
    import { params, goto } from "@roxi/routify";
    import { format, locale } from "svelte-i18n";
    import { token, user } from "../../user/user.state.svelte.js";
    import TableReference from "../../../components/table-reference.svelte";
    import vulnerabilitiesAPI from "../../vulnerability/vulnerabilities.api.js";

    $params;

    import dayjs from "dayjs";

    dayjs.locale($locale);

    let {
        tags = [],
        associations = [],
        parent = "",
        showRefresh = false,
        showActions = true,
        showTitle = true,
        table_is_expanded = false,
        show_expand_button = false,
        refreshFunc,
        graphicsData = {},
    } = $props();

    const sortByPriority = (data) =>
        [...data].sort((a, b) => b.priority - a.priority);

    let data = $derived.by(() => {
        return sortByPriority(findings.list.data);
    });

    let tableElement = $state();
    let selected_rows = $state([]);
    let lang = $state($locale);
    let users = $state([]);
    let formEditModal;
    let checkbox;
    let btns;
    let searchInput = $state("");
    let ptInstructs = $state([]);
    let stateLabels = {
        open: $format("finding.status.open"),
        accepted: $format("finding.status.accepted"),
        fixed: $format("finding.status.fixed"),
        false_positive: $format("finding.status.false_positive"),
    };

    tags = tags.sort((a, b) => a.name.localeCompare(b.name));

    /* START LIST FUNCTIONS */

    const blurRow = async (row) => {
        await tick();
        let index = row.__PT_ID__;
        let rowToBlur = document.querySelector(
            `div[data-prefix='findingTable'] [data-id='${index}']`,
        );

        if (rowToBlur) {
            const allTds = rowToBlur.querySelectorAll("td");

            allTds.forEach((td) => {
                const key = td.getAttribute("data-key");

                if (key !== "asset") {
                    // Fade out all non-asset columns
                    td.style.opacity = "0.7";
                }

                if (key === "asset") {
                    // Keep the asset cell itself fully opaque
                    td.style.opacity = "1";

                    // Find the button inside this specific td and fade it
                    const button = td.querySelector("button");
                    if (button) {
                        button.style.opacity = "0.7";
                    }
                }
            });
        }
    };

    const unblurRow = async (row) => {
        await tick();
        let index = row.__PT_ID__;
        let rowToBlur = document.querySelector(
            `div[data-prefix='findingTable'] [data-id='${index}']`,
        );

        if (rowToBlur) {
            const allTds = rowToBlur.querySelectorAll("td");

            allTds.forEach((td) => {
                const key = td.getAttribute("data-key");

                if (key !== "asset") {
                    // Fade out all non-asset columns
                    td.style.opacity = "1";
                }

                if (key === "asset") {
                    // Keep the asset cell itself fully opaque
                    td.style.opacity = "1";

                    // Find the button inside this specific td and fade it
                    const button = td.querySelector("button");
                    if (button) {
                        button.style.opacity = "1";
                    }
                }
            });
        }
    };


    const customSearch = (event) => {
        let searchInput = event.target.value;
        let result = JSON.parse(JSON.stringify(findings.list.data));
        if (searchInput.length < 1) {
            result = JSON.parse(
                JSON.stringify($state.snapshot(findings.list.data)),
            );
            return (data = sortByPriority(result));
        }
        let input = normalizeString(searchInput);

        function searchListValue(list, input, col) {
            let names = "";
            for (let item of list) {
                names = names + " " + item.name;
            }
            return names.includes(input);
        }

        result = result.filter((item) => {
            if (
                (item.vulnerability
                    ? normalizeString(item.vulnerability).includes(
                          normalizeString(input),
                      )
                    : false) ||
                (item.vulnerability_id
                    ? normalizeString(item.vulnerability_id).includes(
                          normalizeString(input),
                      )
                    : false) ||
                (item.title
                    ? normalizeString(item.title).includes(
                          normalizeString(input),
                      )
                    : false) ||
                (item.description
                    ? normalizeString(item.description).includes(
                          normalizeString(input),
                      )
                    : false)
            ) {
                return true;
            }
            if (item.asset) {
                if (
                    normalizeString(item.asset.name).includes(
                        normalizeString(input),
                    )
                ) {
                    return true;
                }
            }
            if (item.user_id) {
                let usr = users.find((usr) => usr.id == item.user_id);
                if (usr.email.includes(input)) {
                    return true;
                }
            }
            if (item.hasOwnProperty("sla_days_remaining")) {
                let temp = document.createElement("div");
                temp.innerHTML = item.sla_days_remaining;
                item.sla_days_remaining =
                    temp.textContent || temp.innerText || "-";
            }
            if (item.priority) {
                if (item.priority.toPrecision(2).includes(input)) {
                    return true;
                }
            }
            if (item.status) {
                if (
                    normalizeString(stateLabels[item.status]).includes(
                        normalizeString(input),
                    )
                ) {
                    return true;
                }
            }
            if (item.tag) {
                if (searchListValue(item.tag, input, "tag")) {
                    return true;
                }
            }
            if (item.scanner) {
                if (
                    normalizeString(item.scanner).includes(
                        normalizeString(input),
                    )
                ) {
                    return true;
                }
            }
            if (item.first_discovery_at) {
                if (dateText(item.first_discovery_at).includes(input)) {
                    return true;
                }
            }
            if (item.last_discovery_at) {
                if (dateText(item.last_discovery_at).includes(input)) {
                    return true;
                }
            }
            if (item.last_fixed_at) {
                if (dateText(item.last_fixed_at).includes(input)) {
                    return true;
                }
            }
            return false;
        });
        result = result;
        data = sortByPriority(result);
    };

    const showContent = (kind, id) => {
        let visibleElement = document.getElementById(kind + "-visible-" + id);
        let hiddenElement = document.getElementById(kind + "-hidden-" + id);
        visibleElement.classList.remove("is-visible");
        visibleElement.classList.add("is-hidden");
        hiddenElement.classList.remove("is-hidden");
        hiddenElement.classList.add("is-visible");
    };

    const hideContent = (kind, id) => {
        let visibleElement = document.getElementById(kind + "-visible-" + id);
        let hiddenElement = document.getElementById(kind + "-hidden-" + id);
        visibleElement.classList.add("is-visible");
        visibleElement.classList.remove("is-hidden");
        hiddenElement.classList.add("is-hidden");
        hiddenElement.classList.remove("is-visible");
    };

    const selectAll = async (e) => {
        let tData = tableElement.getData(false, ["pageData", "matchedData"]);
        let pageData = tData.pageData;
        if (!pageData || pageData.length === 0) return selected_rows;

        // 1. Check if the page is fully selected to determine select vs deselect mode
        const selectedIds = new Set(selected_rows.map((r) => r.id));
        const allPageSelected = pageData.every((el) => selectedIds.has(el.id));

        let action = allPageSelected ? "deselect" : "select";

        // 2. Handle selection logic
        if (action === "select") {
            let result;
            if (tData.matchedData.length > 10) {
                result = await notificate("select_all", "modal", {});

                if (!result.isConfirmed && result.dismiss !== "cancel") {
                    return selected_rows;
                }
            }

            let target_elements =
                result && result.isConfirmed ? tData.matchedData : pageData;
            const currentIds = new Set(selected_rows.map((x) => x.id));
            let toAdd = target_elements.filter((x) => !currentIds.has(x.id));

            selected_rows = [...selected_rows, ...toAdd];
        } else {
            // Deselect mode: clear everything
            selected_rows = [];
        }

        // 3. Update DOM and action buttons
        powerTableService.toggleActionButtons(selected_rows);

        const domRows = document.querySelectorAll(
            `div[data-prefix='findingTable'] table tbody tr`,
        );

        // Map the PT_ID to a fast lookup set of strict strings
        const selectedPtIds = new Set(
            selected_rows.map((r) => String(r.__PT_ID__)),
        );

        domRows.forEach((row) => {
            let rowId = row.getAttribute("data-id");
            if (selectedPtIds.has(rowId)) {
                row.classList.add("selected");
            } else {
                row.classList.remove("selected");
            }
        });

        return selected_rows;
    };

    const deselectAll = () => {
        selected_rows = powerTableService.deselectAll();
        powerTableService.toggleActionButtons(selected_rows);
        return selected_rows;
    };

    const selectAllEventListener = () => {
        checkbox = document.querySelector(
            "th[data-key='select'][data-sortable='false']",
        );
        if (checkbox) {
            checkbox.addEventListener("click", selectAll);
        }
    };

    const selectRow = (event) => {
        console.log(event, "event");
        if (!showActions) return;
        let tData = tableElement.getData(false, [
            "options",
            "instructs",
            "data",
            "search",
            "filters",
            "pageData",
            "matchedData",
        ]);
        let current = event.detail.data;
        let idx = selected_rows.findIndex((r) => r.id == current.id);
        selected_rows = powerTableService.selectRows(
            selected_rows,
            current,
            idx,
            "findingTable",
            tData.pageData,
        );
        powerTableService.toggleActionButtons(selected_rows);
        return selected_rows;
    };

    const parseRows = (pageContent) => {
        pageContent.forEach((row) => {
            if (row["vulnerability"]) {
                row["vulnerability"] = {
                    label: row.vulnerability,
                    vul_id: row.vulnerability_id,
                    id: row.id,
                    path: "/finding",
                    title: "Ver hallazgo",
                };
            }

            row["title"] = {
                label: row.title || row.id,
                id: row.id,
                path: "/finding",
                title: "Ver hallazgo",
            };

            if (row["asset"]) {
                let asset =
                    typeof row.asset == "string"
                        ? JSON.parse(row.asset)
                        : row.asset;
                row["asset"] = {
                    id: asset.id,
                    label: asset.name,
                    path: "/asset/" + asset.kind,
                    title: $format("buttons.quick_view"),
                    link: true,
                    kind: asset.kind,
                    asset: asset,
                };
            }
            if (row["user_id"]) {
                let usr = users.filter((usr) => usr.id == row["user_id"])[0];
                row["user_id"] = usr && usr.email ? usr.email : "";
            }
            if (row["priority"]) {
                row["priority"] =
                    `<div class="cvss-badge cvss-${row.level || "none"}" style="--mwidth: 70px">${parseFloat(row.priority).toPrecision(2)}</div>`;
            } else {
                if (findings.list.loading)
                    row.priority = `<div><i class="fas fa-sync-alt fa-spin"></i></div>`;
            }
            if (row["status"]) {
                row["status"] = `${stateLabels[row.status]}`;
            }
            if (row["first_discovery_at"]) {
                row["first_discovery_at"] =
                    `<span title="${row.first_discovery_at}">${dateText(row.first_discovery_at)}</span>`;
            }
            if (row["last_discovery_at"]) {
                row["last_discovery_at"] =
                    `<span title="${row.last_discovery_at}">${dateText(row.last_discovery_at)}</span>`;
            }
            if (row["last_fixed_at"]) {
                row["last_fixed_at"] =
                    `<span title="${row.last_fixed_at}">${dateText(row.last_fixed_at)}</span>`;
            }
            if (row.hasOwnProperty("sla_days_remaining")) {
                let sla = row["sla_days_remaining"];
                if (sla === null || sla === undefined || sla === "") {
                    row["sla_days_remaining"] =
                        `<span class="text-muted">-</span>`;
                } else if (Number(sla) > 0) {
                    row["sla_days_remaining"] =
                        `<span class="badge text-bg-success px-2 py-1">${sla}</span>`;
                } else {
                    row["sla_days_remaining"] =
                        `<span class="badge text-bg-danger px-2 py-1">${sla}</span>`;
                }
            }
            if (
                row.status === "Solucionado" ||
                row.status === "Falso positivo" ||
                row.status === "Fixed" ||
                row.status === "False positive"
            ) {
                blurRow(row);
            } else {
                unblurRow(row);
            }
            if (row["tag"]) {
                row.tag = powerTableService.parseTagsRow(
                    row.tag,
                    row.__PT_ID__,
                );
            }
        });
        deselectAll();
        return pageContent;
    };

    const sortNumbers = (v1, v2) => {
        return parseFloat(v1) < parseFloat(v2)
            ? -1
            : parseFloat(v1) > parseFloat(v2)
              ? 1
              : 0;
    };

    let ptOptions = $state({
        uniquePrefix: "findingTable",
        rowsPerPageOptions: [10, 20, 50, 100],
        footerText: false,
        footerFilters: false,
        footerLoadingBar: false,
        segments: {
            pTable: ["table"],
            bottomBar: ["dropdown", "stats", "pagination"],
        },
        translations: {
            add: $format("list.interface.add"),
            delete: $format("list.interface.delete"),
            filterBy: $format("list.interface.filterBy"),
            from: $format("list.interface.from"),
            invertSelection: $format("list.interface.invertSelection"),
            next: $format("list.interface.next"),
            of: $format("list.interface.of"),
            previous: $format("list.interface.previous"),
            rows: $format("list.interface.rows"),
            search: $format("list.interface.search"),
            selectAll: $format("list.interface.selectAll"),
            selectNone: $format("list.interface.selectNone"),
        },
        isDataRemote: false,
        userFunctions: {
            customParse: parseRows,
        },
    });

    /* END LIST FUNCTIONS */

    /* START EXPORT FUNCTIONS */
    const exportToCSV = async () => {
        let instructs = ptInstructs;
        let header = [];
        let titles = [];
        const data = tableElement.getData(false, "matchedData").matchedData;
        let items = JSON.parse(JSON.stringify(data));

        if (parent == "vulnerability") {
            header.push({ key: "vulnerability", value: "Vulnerabilidad" });
            titles.push("Vulnerabilidad");
        }
        if (parent == "asset") {
            header.push({ key: "asset", value: "Activo" });
            titles.push("Activo");
        }

        for (let item of items) {
            if (item.asset) {
                const asset = isJson(item.asset)
                    ? JSON.parse(item.asset)
                    : item.asset;
                item.asset = asset.name;
            }
            if (item.vulnerability) {
                item.vulnerability = item.vulnerability.replaceAll('"', "'");
            }
            if (item.description) {
                item.description = item.description.replaceAll('"', "'");
            }
            if (item.status) {
                item.status = stateLabels[item.status];
            }
            if (item.priority) {
                item.priority = parseFloat(item.priority).toPrecision(2);
            }
            if (item.user_id) {
                let usr = users.find((usr) => usr.id == item.user_id);
                item.user_id = usr.email;
            }
            let tags = isJson(item.tag) ? JSON.parse(item.tag) : [];
            let tagNames = [];
            for (let tag of tags) {
                tagNames.push(tag.name);
            }
            item.tag = tagNames.join(", ");
        }
        const replacer = (key, value) => (value === null ? "" : value); // specify how you want to handle null values here

        Object.keys(items[0]).forEach((item, i) => {
            instructs.forEach((col) => {
                if (col.key === item) {
                    if (col.title.includes(" "))
                        col.title = col.title.replace(" ", "_");
                    header.push({ key: item, value: col.title });
                    titles.push(col.title);
                }
            });
        });

        const csv = [
            titles.join(";"), // header row first
            ...items.map((row) =>
                header
                    .map((fieldName) =>
                        JSON.stringify(row[fieldName["key"]], replacer),
                    )
                    .join(";"),
            ),
        ].join("\r\n");

        let hiddenElement = document.createElement("a");
        hiddenElement.href =
            "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
        hiddenElement.target = "_blank";
        hiddenElement.download = "Hallazgos_vulseek.csv";
        hiddenElement.click();
    };

    const isJson = (str) => {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    };

    const exportJSONData = (e) => {
        let matchedData = tableElement.getData(
            false,
            "matchedData",
        ).matchedData;
        let currentData = JSON.parse(JSON.stringify(matchedData));
        for (let item of currentData) {
            delete item.__PT_ID__;
            delete item.__PT_CB__;
            for (let [k, v] of Object.entries(item)) {
                if (typeof v === "string" && isJson(item[k])) {
                    item[k] = JSON.parse(v);
                }
            }
        }
        // Download JSON object as a file from browser (https://stackoverflow.com/a/30800715)
        let dataStr =
            "data:text/json;charset=utf-8," +
            encodeURIComponent(JSON.stringify(currentData));
        let downloadAnchorNode = document.createElement("a");
        downloadAnchorNode.setAttribute("href", dataStr);
        downloadAnchorNode.setAttribute("download", "Hallazgos_vulseek.json");
        document.body.appendChild(downloadAnchorNode); // required for firefox
        downloadAnchorNode.click();
        downloadAnchorNode.remove();
    };

    /* END EXPORT FUNCTIONS */

    /* START COPY ALL DATA FUNCTION */

    const copyAllDataToClipboard = async () => {
        try {
            // Determine current language
            const currentLang = $locale;

            // Generate CSV table data (reuse exportToCSV logic)
            let instructs = ptInstructs;
            let header = [];
            let titles = [];
            const data = tableElement.getData(false, "matchedData").matchedData;
            let items = JSON.parse(JSON.stringify(data));

            if (parent == "vulnerability") {
                header.push({ key: "vulnerability", value: "Vulnerabilidad" });
                titles.push("Vulnerabilidad");
            }
            if (parent == "asset") {
                header.push({ key: "asset", value: "Activo" });
                titles.push("Activo");
            }

            for (let item of items) {
                if (item.asset) {
                    const asset = isJson(item.asset)
                        ? JSON.parse(item.asset)
                        : item.asset;
                    item.asset = asset.name;
                }
                if (item.vulnerability) {
                    item.vulnerability = item.vulnerability.replaceAll(
                        '"',
                        "'",
                    );
                }
                if (item.description) {
                    item.description = item.description.replaceAll('"', "'");
                }
                if (item.status) {
                    item.status = stateLabels[item.status];
                }
                if (item.priority) {
                    item.priority = parseFloat(item.priority).toPrecision(2);
                }
                if (item.user_id) {
                    let usr = users.find((usr) => usr.id == item.user_id);
                    item.user_id = usr.email;
                }
                let tags = isJson(item.tag) ? JSON.parse(item.tag) : [];
                let tagNames = [];
                for (let tag of tags) {
                    tagNames.push(tag.name);
                }
                item.tag = tagNames.join(", ");
            }
            const replacer = (key, value) => (value === null ? "" : value); // specify how you want to handle null values here

            Object.keys(items[0]).forEach((item, i) => {
                instructs.forEach((col) => {
                    if (col.key === item) {
                        if (col.title.includes(" "))
                            col.title = col.title.replace(" ", "_");
                        header.push({ key: item, value: col.title });
                        titles.push(col.title);
                    }
                });
            });

            const csv = [
                titles.join(";"), // header row first
                ...items.map((row) =>
                    header
                        .map((fieldName) =>
                            JSON.stringify(row[fieldName["key"]], replacer),
                        )
                        .join(";"),
                ),
            ].join("\r\n");

            // Generate JSON graphics data with proper titles
            // Get vulnerability kind names from the API
            const vulKinds = vulnerabilitiesAPI.kinds();
            const vulKindMap = {};
            vulKinds.forEach((kind) => {
                // Map the ID prefix to the full name
                const prefix = kind.id.replace("-", "");
                vulKindMap[prefix] = kind.name;
            });

            // Transform the vulnerability kinds data to use proper names
            const transformedVulKinds = {};
            if (graphicsData.findingsByVulnerabilitKind) {
                Object.entries(graphicsData.findingsByVulnerabilitKind).forEach(
                    ([key, value]) => {
                        const displayName = vulKindMap[key] || key;
                        transformedVulKinds[displayName] = value;
                    },
                );
            }

            const graphicsSection = {
                [currentLang === "es"
                    ? "hallazgos_por_severidad"
                    : "findings_by_severity"]:
                    graphicsData.findingsBySeverity || {},
                [currentLang === "es"
                    ? "hallazgos_por_tipo_de_activo"
                    : "findings_by_asset_kind"]:
                    graphicsData.findingsByAssetKind || {},
                [currentLang === "es"
                    ? "hallazgos_por_tipo_de_vulnerabilidad"
                    : "findings_by_vulnerability_kind"]: transformedVulKinds,
                [currentLang === "es"
                    ? "top_5_vulnerabilidades_con_mas_hallazgos"
                    : "top_5_vulnerabilities_with_most_findings"]:
                    graphicsData.vulnerabilityTopFive || [],
            };

            // Convert graphics data to formatted JSON
            const jsonData = JSON.stringify(graphicsSection, null, 2);

            // Combine both datasets with clear, language-specific headers
            const combinedData =
                `# ${currentLang === "es" ? "HALLAZGOS" : "FINDINGS"} (CSV)\n` +
                csv +
                `\n\n# ${currentLang === "es" ? "GRÁFICOS" : "GRAPHICS"} (JSON)\n` +
                jsonData;

            // Copy to clipboard
            await navigator.clipboard.writeText(combinedData);

            // Show success notification
            notificate("copied", "toast", {
                data: $format("copied"),
            });
        } catch (err) {
            // Show error notification
            notificate("save_error", "toast", {
                data: $format("buttons.copy_to_clipboard_failed"),
            });
        }
    };

    /* END COPY ALL DATA FUNCTION */

    /* START SORTING FUNCTIONS */

    /* END SORTING FUNCTIONS */

    const handleEdit = async (selected_findings) => {
        if (selected_findings.length < 1)
            return notificate("select_element", "modal");
        jQuery("#finding-edit-modal").modal({ show: true });
    };

    const closeEditModal = () => {
        jQuery("#finding-edit-modal").modal("hide");
    };

    const openTagModal = () => {
        jQuery("#tag-add-modal").modal("show");
    };

    const closeTagModal = () => {
        jQuery("#tag-add-modal").modal("hide");
        let element = document.getElementById("tagsSelect");
        if (element) element.selectedIndex = 0;
    };

    const openTagRemoveModal = () => {
        jQuery("#tag-remove-modal").modal("show");
    };

    const closeRemoveTagModal = async () => {
        jQuery("#tag-remove-modal").modal("hide");
        document.getElementById("tagsSelect").selectedIndex = 0;
        let newData = await hydrateFindingsWithTags(data);
        findings.list.data = newData;
    };

    const handleAddTag = (event) => {
        let tag = { target: { value: event.detail.savedTag.id } };
        handleTagEditFn(tag);
    };

    const handleTagEditFn = async (element) => {
        let value = element.target.value;
        let requestData = [];

        if (value == "cancel") return;
        if (value == "removeTags") {
            if (selected_rows.length > 1)
                return notificate("select_only_one", "modal");
            return openTagRemoveModal();
        }
        if (value == "addNewTag") {
            if (selected_rows.length <= 0)
                return notificate("select_element", "modal");
            return openTagModal();
        } else {
            let nodes = selected_rows;
            let finding_ids = new Set(nodes.map((node) => node.id));
            let findingsToEdit = data.filter((finding) =>
                finding_ids.has(finding.id),
            );

            if (findingsToEdit.length === 0) {
                return notificate("select_element", "modal");
            }
            for (let finding of findingsToEdit) {
                requestData.push({
                    tag_id: value,
                    target_object_type: "Finding",
                    target_object_id: finding.id,
                });
            }
            let response = await MassiveActionsService.handleTagAssociation(
                requestData,
                {},
            );
            if (response.errors.length === 0) {
                notificate("save_ok", "toast", {
                    data: $format("finding.plural"),
                    is_massive: true,
                });
                let newData = await hydrateFindingsWithTags(data);
                replaceFindingsListElements(newData);
            } else {
                let failed_findings_ids = [];
                for (let error of response.errors) {
                    failed_findings_ids.push(error.target_object_id);
                }
                let failed = findingsToEdit.filter((finding) =>
                    failed_findings_ids.includes(finding.id),
                );
                let newData = await hydrateFindingsWithTags(data);
                findings.list.data = newData;
                for (let fail of failed) {
                    let toastConfig = {
                        data: fail.name,
                        options: {
                            timeOut: "0",
                            extendedTimeOut: "0",
                            showDuration: "0",
                            hideDuration: "0",
                            closeButton: true,
                        },
                    };
                    notificate("save_error", "toast", toastConfig);
                }
            }
        }
        closeTagModal();
        selected_rows = [];
    };

    const refresh = async () => {
        if (refreshFunc) {
            await refreshFunc();
        } else {
            await searchFindings("v2/finding/", {
                filter: $params,
                buildList: {
                    tags: { elements: tags, associations: associations },
                },
            });
        }
    };

    const handleInstructs = () => {
        if (showActions)
            ptInstructs.push({
                key: "select",
                title: "",
                filterable: false,
                sortable: false,
            });

        ptInstructs.push(
            {
                key: "priority",
                title: $format("list.columns.priority"),
                filterable: false,
                parseAs: "unsafe-html",
                userFunctions: { customSort: sortNumbers },
            },
            {
                key: "vulnerability",
                title: $format("list.columns.finding"),
                filterable: false,
                parseAs: "component",
                dataComponent: FindingTableHtmlRow,
            },
        );

        if (parent) {
            let assetCol = {
                key: "asset",
                title: $format("list.columns.asset"),
                filterable: false,
                parseAs: "component",
                dataComponent: FindingAssetRow,
            };
            let leakCol = {
                key: "breachDate",
                title: $format("list.columns.leaked"),
                filterable: false,
            };
            if (parent === "finding") {
                ptInstructs = [...ptInstructs, assetCol];
            }
            if (parent === "email") {
                ptInstructs = [...ptInstructs, leakCol];
            }
            if (parent === "vulnerability") {
                ptInstructs = [...ptInstructs, assetCol];
            }
            if (parent === "leak") {
                ptInstructs = [...ptInstructs, assetCol, leakCol];
            }
        }
        ptInstructs = [
            ...ptInstructs,
            {
                key: "description",
                title: $format("list.columns.description"),
                filterable: false,
                parseAs: "component",
                dataComponent: DescriptionRow,
            },
            {
                key: "user_id",
                title: $format("list.columns.assigned"),
                filterable: false,
            },
            {
                key: "first_discovery_at",
                title: $format("list.columns.created"),
                filterable: false,
                parseAs: "unsafe-html",
                userFunctions: { customSort: powerTableService.sortDates },
            },
            {
                key: "last_discovery_at",
                title: $format("list.columns.seen"),
                filterable: false,
                parseAs: "unsafe-html",
                userFunctions: { customSort: powerTableService.sortDates },
            },
            {
                key: "sla_days_remaining",
                title: "SLA",
                filterable: false,
                parseAs: "unsafe-html",
            },
            {
                key: "status",
                title: $format("list.columns.status"),
                filterable: false,
            },
            {
                key: "tag",
                title: $format("list.columns.tag"),
                filterable: false,
                parseAs: "unsafe-html",
            },
            { key: "scanner", title: "Scanner", filterable: false },
        ];

        if (parent && parent === "leak") {
            ptInstructs = ptInstructs.filter(
                (col) =>
                    col.key != "last_fixed_at" &&
                    col.key != "last_discovery_at" &&
                    col.key != "first_discovery_at",
            );
        }
    };

    const changeTitleLang = async (new_lang) => {
        let cleanInstructs = $state.snapshot(ptInstructs);

        let newInstructs = cleanInstructs.map((col) => {
            if (new_lang == "en" && col.key == "vulnerability") {
                return { ...col, key: "title" };
            }
            if (new_lang == "es" && col.key == "title") {
                return { ...col, key: "vulnerability" };
            }
            return col;
        });

        ptInstructs = [];
        await tick();
        lang = new_lang;
        ptInstructs = newInstructs;
    };

    const getUsers = async () => {
        if (!token.access_token) return [];
        return (users = await userService.search());
    };

    const handleKeydown = (event) => {
        // let page = tableElement.getData().options.currentPage;
        // if(event.keyCode == 39){
        //     ptOptions.currentPage = page + 1 ;
        // }
        // if(event.keyCode == 37){
        //     if((page - 1) > 0){
        //         ptOptions.currentPage = page -1 ;
        //     }
        //     else {
        //         return;
        //     }
        // }
        // else {
        return;
        //}
    };

    onMount(async () => {
        await getUsers();
        formEditModal = jQuery("#finding-edit-modal").modal({ show: false });
        handleInstructs();
        await tick();
        selectAllEventListener();
    });

    onDestroy(() => {
        if (checkbox) checkbox.removeEventListener("click", selectAll);
    });

    window.showContent = showContent;
    window.hideContent = hideContent;
</script>

<svelte:window onkeydown={handleKeydown} />
<!-- {#if !findings.errors} -->
<!-- {#await getUsers() then success} -->
<div class="card mt-3">
    <div class="card-header">
        <div class="float-start">
            {#if ptInstructs.length > 0}
                <TableReference
                    columnsDefinition={ptInstructs}
                    list={"finding"}
                />
            {/if}
        </div>
        <div class="float-end d-flex">
            {#if $locale != "en"}
                <button
                    class="btn btn-secondary table-button btn-language btn-xs"
                    title={lang == "es"
                        ? "Ver idioma original"
                        : "Ver idioma seleccionado"}
                    onclick={() => changeTitleLang(lang == "es" ? "en" : "es")}
                >
                    {#key lang}
                        {#if lang == "es"}
                            <i class="flag-icon flag-icon-ar"></i>
                        {:else}
                            <i class="flag-icon flag-icon-us"></i>
                        {/if}
                    {/key}
                </button>
            {/if}

            {#if showActions}
                {#if user.data.role != "viewer"}
                    <button
                        class="btn btn-secondary table-button btn-edit btn-xs btn-disabled t-edit-finding-btn"
                        tabindex="0"
                        aria-controls="findingTable"
                        type="button"
                        title={$format("edit")}
                        id="finding-btn-edit"
                        onclick={() => handleEdit(selected_rows)}
                        ><i class="fa fa-edit"></i></button
                    >
                {/if}
                {#if showRefresh && showActions}
                    <button
                        class="btn btn-secondary table-button btn-refresh btn-xs t-refresh-finding-btn"
                        tabindex="0"
                        aria-controls="findingTable"
                        type="button"
                        title={$format("buttons.refresh")}
                        id="findingRefreshBtn"
                        onclick={() => refresh()}
                        ><i class="fa fa-sync-alt"></i></button
                    >
                {/if}
                <button
                    class="btn btn-secondary table-button btn-export btn-xs t-json-finding-btn"
                    tabindex="0"
                    aria-controls="findingTable"
                    type="button"
                    title={$format("buttons.json")}
                    id="tagJSONbtn"
                    onclick={exportJSONData}
                    ><i class="fab fa-js-square" style="font-size: 18px;"
                    ></i></button
                >
                <button
                    class="btn btn-secondary table-button btn-export btn-xs t-csv-finding-btn"
                    tabindex="0"
                    aria-controls="findingTable"
                    type="button"
                    title={$format("buttons.csv")}
                    id="tagCSVbtn"
                    onclick={exportToCSV}
                    ><i class="fa fa-file-csv" style="font-size: 18px;"
                    ></i></button
                >
                <button
                    class="btn btn-secondary table-button btn-export btn-xs t-copy-all-btn"
                    tabindex="0"
                    aria-controls="findingTable"
                    type="button"
                    title={$format("buttons.copy_to_clipboard")}
                    id="findingCopyAllBtn"
                    onclick={copyAllDataToClipboard}
                    ><i class="fa fa-copy" style="font-size: 18px;"></i></button
                >
                {#if user.data.role != "viewer"}
                    <select
                        disabled
                        id="tagsSelect"
                        name="tagsSelect"
                        class="form-control btn-disabled"
                        style="height: 28px; clear: left; float: right; max-width: 180px;font-size: 12px; margin-right: 10px;"
                        oninput={(e) => handleTagEditFn(e)}
                    >
                        <option value="cancel"
                            >{$format("buttons.select_tag.select")}</option
                        >
                        <option disabled>----------</option>
                        <option value="addNewTag"
                            >{$format(
                                "buttons.select_tag.add_and_associate",
                            )}</option
                        >
                        <option disabled>----------</option>
                        <option value="removeTags"
                            >{$format("buttons.select_tag.remove")}</option
                        >
                        <option disabled>----------</option>
                        {#each tags as tag}
                            <option value={tag.id}>{tag.name}</option>
                        {/each}
                    </select>

                    <select
                        id="changeFindingOwner"
                        class="form-control btn-disabled"
                        name="changeFindingOwner"
                        oninput={(e) =>
                            handleOwnerChange(selected_rows, e.target.value)}
                        style="height: 28px; clear: left; float: right; max-width: 180px; font-size: 12px; margin-right: 10px;"
                    >
                        <option value="cancel"
                            >{$format("buttons.assign_finding.assign")}</option
                        >
                        <option value="null"
                            >{$format("buttons.assign_finding.remove")}</option
                        >
                        {#each users as user}
                            <option value={user.id}>{user.email}</option>
                        {/each}
                    </select>

                    <select
                        disabled
                        id="changeFindingsStatus"
                        class="form-control btn-disabled"
                        name="changeFindingsStatus"
                        oninput={(e) =>
                            handleStatusChange(selected_rows, e.target.value)}
                        style="height: 28px; clear: left; float: right; max-width: 180px; font-size: 12px; margin-right: 10px;"
                    >
                        <option value="cancel"
                            >{$format("buttons.change_status")}</option
                        >
                        <option value="open"
                            >{$format("finding.status.open")}</option
                        >
                        <option value="accepted"
                            >{$format("finding.status.accepted")}</option
                        >
                        <option value="fixed"
                            >{$format("finding.status.fixed")}</option
                        >
                        <option value="false_positive"
                            >{$format("finding.status.false_positive")}</option
                        >
                    </select>
                {/if}
            {/if}
        </div>
    </div>
    <div class="card-body">
        <div class="table-responsive">
            <form class="form-inline" novalidate>
                <div class="input-group input-group-sm">
                    <input
                        class="form-control custom-search"
                        placeholder={$format("filter")}
                        data-name="search-input"
                        type="text"
                        bind:value={searchInput}
                        oninput={customSearch}
                    />
                    <div class="input-group-append">
                        <i class="fas fa-search"></i>
                    </div>
                </div>
            </form>
            <PowerTable
                ptData={data}
                {ptInstructs}
                {ptOptions}
                on:rowClicked={(e) => selectRow(e)}
                bind:this={tableElement}
            >
                {#snippet noResults()}
                    <div>
                        {$format("results_not_found")}
                    </div>
                {/snippet}
            </PowerTable>
        </div>
    </div>
</div>
<div
    class="modal fade show"
    id="finding-edit-modal"
    style="display: none; padding-right: 9px;"
    aria-modal="true"
    role="dialog"
>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    {$format("buttons.edit")}
                    {$format("findings")}
                </h4>
                <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                >
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                {#key selected_rows}
                    <EditForm {selected_rows} {closeEditModal} />
                {/key}
            </div>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>
<!-- END MODAL-->
<!-- {/await} -->
<!-- {:else}
    <div>{findings.errors}</div>
{/if} -->

<!-- TAG MODAL -->
<div
    class="modal fade show"
    id="tag-add-modal"
    style="display: none; padding-right: 9px;"
    aria-modal="true"
    role="dialog"
>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{$format("page.tag.add")}</h4>
                <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                >
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <TagForm
                    on:save={handleAddTag}
                    on:closeModal={closeTagModal}
                    tag={null}
                />
            </div>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>
<!-- END TAG MODAL-->

<!-- REMOVE TAG MODAL -->
<div
    class="modal fade show"
    id="tag-remove-modal"
    style="display: none; padding-right: 9px;"
    aria-modal="true"
    role="dialog"
>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{$format("page.tag.remove")}</h4>
                <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                >
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                {#key selected_rows}
                    <RemoveFindingTag
                        finding={selected_rows[0]}
                        on:closeModal={closeRemoveTagModal}
                        on:removeTags={closeRemoveTagModal}
                    />
                {/key}
            </div>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>

<!-- END TAG MODAL-->

<style>
    .custom-search {
        background-color: whitesmoke;
        border-color: #e8e8e8;
        color: rgba(52, 58, 64, 0.8);
    }
    .input-group-append {
        position: absolute;
        right: 25px;
        top: 0.5em;
        z-index: 99999;
    }
    .input-group-append .fas.fa-search {
        color: rgba(52, 58, 64, 0.8);
    }
    .input-group {
        width: 25%;
        position: relative;
    }
</style>
